import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { useDispatch } from "react-redux";
import defaultConfig from "../../config/Config";
import
{ Tooltip as ReactTooltip }  from "react-tooltip";
const Table = function (props) {
  const [totalRows, setTotalRows] = useState(1);
  const [perPage, setPerPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const type = props.type
  const dispatch = useDispatch();
  useEffect(() => {
    if (props.totalCount) {
      setTotalRows(props.totalCount);
    }  
  }, [props.totalCount]);

  useEffect(() => {
    if(props.extraConfig.pageLength){
      setPerPage(parseInt(props.extraConfig.pageLength))
    }

    if(props.extraConfig.page){
      setCurrentPage(parseInt(props.extraConfig.page))
    }
  }, [props?.extraConfig?.pageLength, props?.extraConfig?.page]);

  const handlePerRowsChange = async (newPerPage) => {
    setPerPage(newPerPage);
    let data = {
      pageLength: newPerPage,
      page: currentPage,
    };

    if (props.extraConfig) {
      data = {...props.extraConfig,...data };
    }

    if(typeof props.callBack === "function"){
        
        props.callBack(data)
    } 
    dispatch(props.dataLoadFnc({data, type}));
  };

  const handlePageChange = async (page) => {
    let data = {
      pageLength: perPage,
      page: page
    };
    if (props.extraConfig) {
      data = { ...props.extraConfig, ...data };
    }
    
    setCurrentPage(page);
    if(typeof props.callBack === "function"){
        props.callBack(data)
    }
    dispatch(props.dataLoadFnc({data, type}));
  };

  const handleSort = (column, sortDirection) => {
		// simulate server sort
    let data = {sort: column.id, order: sortDirection}
    if (props.extraConfig) {
      data = { ...props.extraConfig, ...data };
    }
    
    if(typeof props.callBack === "function"){
        props.callBack(data)
    }
    dispatch(props.dataLoadFnc({data, type}));
		// setLoading(true);

		// // instead of setTimeout this is where you would handle your API call.
		// setTimeout(() => {
		// 	setData(orderBy(data, column.sortField, sortDirection));
		// 	setLoading(false);
		// }, 100);
	};

  return (
    <>
      <hr />
    <div className="mb-0 table-responsive">
        {props.data !== "undefined" ? (
          <><DataTable
            //customStyles={dataTableConfig(defaultThemes)}
            onSort={handleSort}
            sortServer
            striped={true}
            noHeader={true}
            persistTableHead={true}
            noDataComponent="Data Is Not Available"
            title="Table"
            columns={props.columns}
            defaultSortFieldID={0}
            paginationDefaultPage={currentPage}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            paginationRowsPerPageOptions={[2, 10, 15, 20, 50]}
            paginationPerPage={defaultConfig.defaultLimit}
            progressPending={props.loading}
            data={props.data} />
            <ReactTooltip id='my-tooltip' place="left" type="success" effect="solid" />
          </>
        ) : (
          ""
        )}
      </div></>
  );
};

export default React.memo(Table);
